import { createContext } from 'react'

import { ReportEditorStore } from 'modules/reports/lib/Store'

export const reportStoreContext = createContext<ReportEditorStore | undefined>(undefined)
